<template>
  <div class="st-error" :role="role">
    <div class="row">
      <div class="col-12">
        <div class="error-box">
          <div class="error-box-icon">
            <component
              :is="icon"
              size="sm"
              name="ic-error-filled-large"
              :alt="alt"
              useSvg
            />
          </div>
          <div class="error-box-text">{{ formattedMessage }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StIcon from "../icon/Icon.vue";
import StIconLegacy from "../icon/IconLegacy.vue";

import { version } from "vue";

export default {
  components: {
    StIcon,
    StIconLegacy,
  },
  props: {
    error: {
      default: function () {
        return { hasError: false };
      },
    },
    alt: {
      type: String,
      default: "",
    },
    errorMessage: {
      type: String,
      required: true,
    },
    unhandledErrorMessage: {
      type: String,
      required: true,
    },
    setRoleAlert: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      role: this.setRoleAlert ? "alert" : null,
    };
  },
  computed: {
    icon() {
      return version && parseInt(version) === 3 ? "StIcon" : "StIconLegacy";
    },
    isStoryBook() {
      return process.env.STORYBOOK_SELF;
    },
    formattedMessage() {
      if (this.error.response && this.error.response.data.message) {
        return this.isStoryBook ? "Error message" : this.errorMessage;
      } else if (this.error && this.error.message) {
        return this.error.message;
      } else {
        return this.isStoryBook
          ? "Error Unhandled"
          : this.unhandledErrorMessage;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../scss/main.scss";
.st-error {
  margin-top: 1.5em;

  .error-box {
    border-radius: 0.25em;
    background-color: $danger-color-secondary;
    border: rem-calc(1) solid $danger-color-primary;
    min-height: 2.25em;
    height: 100%;
    padding: 0.5em 0.9375em;
    vertical-align: middle;

    font-family: $source-sans-pro;
    font-size: 0.875em;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: $text-color-primary;

    display: flex;

    .error-box-icon {
      width: 1.25em;
      margin-right: 0.625em;
    }

    .error-box-text {
      flex: 1;
      height: 100%;
      text-align: left !important;
    }
  }
}
</style>
